import type { ReactNode } from "react";
import { Badge } from "@mui/material";
import { colors, spacing } from "../../../../assets/styles/tokens";

interface IconWithIndicatorProps {
  // Shows the purple dot when true (e.g. a search term or filter is applied).
  active: boolean;
  children: ReactNode;
}

// Wraps a mobile filter-bar icon (search, filter) with the same purple dot
// badge as the Trends mobile filter button (TrendsMobileFilterBy).
export default function IconWithIndicator({ active, children }: IconWithIndicatorProps) {
  return (
    <Badge
      variant="dot"
      invisible={!active}
      sx={{
        "& .MuiBadge-badge": {
          height: spacing.Spacing.lg.$value,
          width: spacing.Spacing.lg.$value,
          borderRadius: spacing.Radius.full.$value,
          backgroundColor: colors.Brand[600].$value,
        },
      }}
    >
      {children}
    </Badge>
  );
}
